import axios from '@/libs/api.request'

export const getLaborcontractlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/laborcontract/laborcontract/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationLaborcontract = (data, meth) => {
  return axios.request({
    url: '/v1/laborcontract/laborcontract/',
    method: meth,
    data
  })
}